module.exports = __webpack_public_path__ + "img/mobi-bg-img.a8228840.svg";